import { UploadButton } from '@bytescale/upload-widget-react';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { ProfilePicture } from 'components/common/ProfilePicture';
import React, { useEffect, useState } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { useDispatch, useSelector } from 'react-redux';
import { cdn } from 'constants/common';
import { setError } from 'slices/userSlice';
import toast from 'react-hot-toast';
import FullPageLoader from 'components/common/FullPageLoader';
import { fetchMainAccountProfile } from 'slices/mainAccount/mainAccountProfileSlice';
import { mainAccountProfileSelector } from 'slices/mainAccount/mainAccountProfileSlice';
import { updateMainAccountProfile } from 'slices/mainAccount/mainAccountProfileSlice';
import { CustomSwitch } from 'components/common/Switch';

const ShowProfile = ({ item, handleEdit }) => {
    const InfoRow = ({ label, value }) => (
        <tr>
            <td className='col-3'><strong>{label}</strong></td>
            <td className='col-9'>{value || 'N/A'}</td>
        </tr>
    );
    return (
        <div className='container_main mt-4 profile-container'>
            <div className="profile-header">
                <div className="profile-image">
                    <ProfilePicture imageUrl="/images/default-person.png" />
                </div>
                <div className="profile-info">
                    <h1 className='text-capitalize'>{item?.user?.name}</h1>
                    <p>{item?.address}</p>
                    <div className="edit_prof">
                        <button type='button' className='main_button' onClick={handleEdit}>
                            <i className="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;
                            <span>Edit Profile</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="profile-section">
                <h2>Personal Information</h2>
                <table>
                    <InfoRow label="Name:" value={item?.user?.name} />
                    <InfoRow label="Email:" value={item?.user?.email} />
                    <InfoRow label="Cell Phone:" value={item?.phone} />
                    <InfoRow label="Role:" value="User" />
                </table>
            </div>

        </div>
    );
};

const Profile = () => {
    const dispatch = useDispatch();
    const methods = useForm();
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors, resetField } = methods;
    const { mainAccountProfile: item, error, loader } = useSelector(mainAccountProfileSelector);
    const [activeEdit, setActiveEdit] = useState(false)
    const [credentialsSend, setCredentialsSend] = useState(1);
    const [notification, setNotification] = useState(1);
    const [localImage, setLocalImage] = React.useState('')

    useEffect(() => {
        Promise.allSettled(
            [dispatch(fetchMainAccountProfile()),]
        )
    }, [])

    useEffect(() => {
        setValue('name', item?.user?.name || '');
        setValue('email', item?.user?.email || '');
        setValue('phone', item?.phone || '');
        setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 1);
        setNotification((typeof (item?.user?.notifications) == "number") ? item?.user?.notifications : 1);
        dispatch(setError({}));
    }, [item, activeEdit, setValue])

    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            dispatch(fetchMainAccountProfile())
            handleCancelEdit()
        }
        else {
            console.log('onSubmit', error)
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const onSubmit = (data) => {
        dispatch(setError({}))
        const newData = {
            ...data,
            credentialsSend,
            notification,
        };
        dispatch(updateMainAccountProfile(newData, submitCallback));
    }

    const options = {
        apiKey: "free",
        maxFileCount: 1
    };

    function handleEdit() {
        dispatch(fetchMainAccountProfile())
        setActiveEdit(true)
    }
    function handleCancelEdit() {
        dispatch(fetchMainAccountProfile())
        setActiveEdit(false)
    }

    return (
        <div className="content">
            <div className="row_main_head">
                <h2 className="main_heading">Profile Page</h2>
            </div>
            {activeEdit === false ?
                <ShowProfile item={item} handleEdit={handleEdit} />
                :
                <div className='container_main mt-4'>
                    <FormProvider {...methods}>
                        <form className='profile_form' onSubmit={handleSubmit(onSubmit)}>

                            {/* Main credientials area  */}
                            <div className='foam_page_row'>
                                <div className="row-primary w-100">
                                    <h2>Profile Picture</h2>

                                    <div className='Upload_wrapper'>
                                        {(localImage || item?.user?.image) &&
                                            <div className='image_preview'>
                                                <ProfilePicture imageUrl={localImage || cdn + item?.user?.image} />
                                            </div>
                                        }
                                        <div className='w-100'>
                                            <Controller name="image" control={control} render={({ field }) =>
                                            (
                                                <UploadButton options={options}
                                                    onComplete={files => {
                                                        const file = files[0];
                                                        setLocalImage(file?.fileUrl);
                                                        field.onChange(file?.originalFile?.file);
                                                    }}>
                                                    {({ onClick }) =>
                                                        <button type='button' onClick={onClick}>
                                                            <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                                                            <span>Upload New</span>
                                                        </button>
                                                    }
                                                </UploadButton>
                                            )}
                                            />
                                            {error?.errors?.image?.map((error) => (
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={error} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="row-primary w-100">
                                    <h2>Name *</h2>
                                    <div className='w-100'>
                                        <Controller name="name" control={control} render={({ field }) => <input className="input-in type_inp" type="text" name='name' placeholder='Name' {...field} />} />
                                        {error?.errors?.name?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary w-100">
                                    <h2>Email *</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="email"
                                            control={control}
                                            render={({ field }) => <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" disabled autoComplete="off" name='email'
                                                pattern={
                                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                }
                                                placeholder="Email Address"
                                                {...field}
                                            />} />
                                        {error?.errors?.email?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary w-100">
                                    <h2>Phone</h2>
                                    <div className='w-100'>
                                        <Controller
                                            name="phone"
                                            control={control}
                                            render={({ field }) => <PhoneInput className={`input-in type_inp ${error?.errors?.phone ? "border-red" : ""} `}
                                                type="tel" name='contact' placeholder='Phone number' {...field} />
                                            }
                                        />
                                        {error?.errors?.phone?.map((error) => (<div style={{ marginTop: 10 }}> <ErrorMessage text={error} /> </div>))}
                                    </div>
                                </div>

                                <div className="row-primary w-100 align-items-center">
                                    <h2 className='m-0'>Credentials will be sent over email</h2>
                                    <label className="custom-checkbox checkbox">
                                        <input type="checkbox" name="credentialsSend" checked={credentialsSend === 1 ? true : false} onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)} />
                                        <span className="checkmark"></span>
                                    </label>
                                </div>

                                <div className="row-primary w-100 align-items-center">
                                    <h2 className='mt-0'>Notification <span className='opacity-50'>(all type of notification regarding appointments)</span></h2>
                                    <CustomSwitch labelText="notifications" checked={notification == 1 ? true : false} handleChange={(checked) => setNotification(checked ? 1 : 0)} />
                                </div>
                            </div>

                            <div className="Form-footer">
                                <button type='button' className='Cancle_button' onClick={handleCancelEdit}>Cancel</button>
                                <SubmitButton btnText={"Update Profile"} loader={loader} />
                            </div>
                        </form>
                    </FormProvider>
                </div>
            }
            {loader && <FullPageLoader loader={loader} />}
        </div>
    )
}

export default Profile